import axiosInstance from 'services/APIService';

const ENDPOINT_PATH = ``;

/*
 * Gets a firebase token from the backend
 */
export const getFirebaseToken = (): Promise<string> =>
  axiosInstance.get<{ token: string }>(`/v1/user/firebase_token`).then(response => response.data.token);

export const getUser = (): Promise<{ userId: string; region: string; location: string }> =>
  axiosInstance.get<{ user_id: string; region: string; location: string }>(`${ENDPOINT_PATH}/v1/user`).then(res => ({
    userId: res.data.user_id,
    region: res.data.region,
    location: res.data.location,
  }));
